// Copyright (c) StrangeBee 2023

import React, { ReactElement, useMemo } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import { THLayout } from '@Molecules/THLayout';
import { useCurrentUser } from '@Queries/userQueries';
import NoMFA from '@Organisms/AccountDetails/NoMFA/NoMFA';
import EditMFA from '@Organisms/AccountDetails/EditMFA/EditMFA';
import { computeEventList } from '@Organisms/AccountDetails/eventList';
import { useLocalMessage } from '@Helpers/locale';
import client from '@Client';
import { handleNotificationError, openMessage } from '@Helpers/notification';

import './MFA.scss';

const MFA = (): ReactElement => {
    const i = useLocalMessage();
    const { data: currentUser, refetch } = useCurrentUser();
    const { hasMFA = false } = currentUser || {};

    const eventList = useMemo(
        () =>
            computeEventList({
                locale: i,
                controller: client.AuthController,
                onSuccess: (_, message) => {
                    if (message) {
                        openMessage('success', message);
                    }
                    refetch();
                },
                onError: handleNotificationError,
            }),
        [i, refetch],
    );

    return (
        <THLayout>
            <THLayout.Content className="mfa">
                {hasMFA ? <NoMFA /> : <EditMFA eventList={eventList} />}
            </THLayout.Content>
        </THLayout>
    );
};

export const Route: RouteType = {
    menu: {
        label: 'MFA',
    },
    path: RouteBuilder.compute('account.mfa'),
    content: <MFA />,
    space: ['admin', 'user'],
    breadcrumb: { label: 'MFA' },
};
